// src/enums/deal-status.enum.ts
var DealStatus = /* @__PURE__ */ ((DealStatus2) => {
  DealStatus2["Draft"] = "draft";
  DealStatus2["Scheduled"] = "scheduled";
  DealStatus2["Active"] = "active";
  DealStatus2["Paused"] = "paused";
  DealStatus2["Expired"] = "expired";
  DealStatus2["Completed"] = "completed";
  return DealStatus2;
})(DealStatus || {});

// src/enums/claim-status.enum.ts
var ClaimStatus = /* @__PURE__ */ ((ClaimStatus2) => {
  ClaimStatus2["Reserved"] = "reserved";
  ClaimStatus2["Rushing"] = "rushing";
  ClaimStatus2["Arrived"] = "arrived";
  ClaimStatus2["Validated"] = "validated";
  ClaimStatus2["Expired"] = "expired";
  ClaimStatus2["Cancelled"] = "cancelled";
  ClaimStatus2["ItemUnavailable"] = "item_unavailable";
  return ClaimStatus2;
})(ClaimStatus || {});

// src/enums/deal-source.enum.ts
var DealSource = /* @__PURE__ */ ((DealSource2) => {
  DealSource2["Merchant"] = "merchant";
  DealSource2["Scraped"] = "scraped";
  return DealSource2;
})(DealSource || {});

// src/enums/category.enum.ts
var Category = /* @__PURE__ */ ((Category2) => {
  Category2["Fashion"] = "fashion";
  Category2["Electronics"] = "electronics";
  Category2["Sports"] = "sports";
  Category2["Beauty"] = "beauty";
  Category2["Food"] = "food";
  Category2["Home"] = "home";
  Category2["Accessories"] = "accessories";
  Category2["Kids"] = "kids";
  Category2["Automotive"] = "automotive";
  Category2["Health"] = "health";
  return Category2;
})(Category || {});

// src/enums/notification-priority.enum.ts
var NotificationPriority = /* @__PURE__ */ ((NotificationPriority2) => {
  NotificationPriority2["P0_WISHLIST"] = "P0_WISHLIST";
  NotificationPriority2["P1_HIGH"] = "P1_HIGH";
  NotificationPriority2["P2_MEDIUM"] = "P2_MEDIUM";
  NotificationPriority2["P3_LOW"] = "P3_LOW";
  return NotificationPriority2;
})(NotificationPriority || {});

// src/enums/user-role.enum.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["Shopper"] = "shopper";
  UserRole2["Merchant"] = "merchant";
  UserRole2["MerchantStaff"] = "merchant_staff";
  UserRole2["Admin"] = "admin";
  return UserRole2;
})(UserRole || {});

// src/enums/decay-status.enum.ts
var DecayStatus = /* @__PURE__ */ ((DecayStatus2) => {
  DecayStatus2["NotStarted"] = "not_started";
  DecayStatus2["Active"] = "active";
  DecayStatus2["Expired"] = "expired";
  return DecayStatus2;
})(DecayStatus || {});

// src/enums/claim-validation-method.enum.ts
var ClaimValidationMethod = /* @__PURE__ */ ((ClaimValidationMethod2) => {
  ClaimValidationMethod2["QrScan"] = "qr_scan";
  ClaimValidationMethod2["ManualCode"] = "manual_code";
  ClaimValidationMethod2["Geofence"] = "geofence";
  return ClaimValidationMethod2;
})(ClaimValidationMethod || {});

// src/enums/error-code.enum.ts
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["R2S_DEAL_EXPIRED"] = "R2S_DEAL_EXPIRED";
  ErrorCode2["R2S_DEAL_FULL"] = "R2S_DEAL_FULL";
  ErrorCode2["R2S_DEAL_NOT_ACTIVE"] = "R2S_DEAL_NOT_ACTIVE";
  ErrorCode2["R2S_DEAL_NOT_FOUND"] = "R2S_DEAL_NOT_FOUND";
  ErrorCode2["R2S_DEAL_LIMIT_REACHED"] = "R2S_DEAL_LIMIT_REACHED";
  ErrorCode2["R2S_DEAL_INVALID_CURVE"] = "R2S_DEAL_INVALID_CURVE";
  ErrorCode2["R2S_CLAIM_EXISTS"] = "R2S_CLAIM_EXISTS";
  ErrorCode2["R2S_CLAIM_NOT_FOUND"] = "R2S_CLAIM_NOT_FOUND";
  ErrorCode2["R2S_CLAIM_ALREADY_VALIDATED"] = "R2S_CLAIM_ALREADY_VALIDATED";
  ErrorCode2["R2S_CLAIM_EXPIRED"] = "R2S_CLAIM_EXPIRED";
  ErrorCode2["R2S_QR_INVALID"] = "R2S_QR_INVALID";
  ErrorCode2["R2S_QR_EXPIRED"] = "R2S_QR_EXPIRED";
  ErrorCode2["R2S_WRONG_STORE"] = "R2S_WRONG_STORE";
  ErrorCode2["R2S_AUTH_REQUIRED"] = "R2S_AUTH_REQUIRED";
  ErrorCode2["R2S_FORBIDDEN"] = "R2S_FORBIDDEN";
  ErrorCode2["R2S_USER_NOT_FOUND"] = "R2S_USER_NOT_FOUND";
  ErrorCode2["R2S_MERCHANT_NOT_FOUND"] = "R2S_MERCHANT_NOT_FOUND";
  ErrorCode2["R2S_LOCATION_REQUIRED"] = "R2S_LOCATION_REQUIRED";
  ErrorCode2["R2S_LOCATION_INVALID"] = "R2S_LOCATION_INVALID";
  ErrorCode2["R2S_RATE_LIMITED"] = "R2S_RATE_LIMITED";
  ErrorCode2["R2S_SUBSCRIPTION_LIMIT"] = "R2S_SUBSCRIPTION_LIMIT";
  ErrorCode2["R2S_SUBSCRIPTION_INACTIVE"] = "R2S_SUBSCRIPTION_INACTIVE";
  ErrorCode2["R2S_WISHLIST_LIMIT"] = "R2S_WISHLIST_LIMIT";
  ErrorCode2["R2S_VALIDATION_ERROR"] = "R2S_VALIDATION_ERROR";
  ErrorCode2["R2S_INTERNAL_ERROR"] = "R2S_INTERNAL_ERROR";
  return ErrorCode2;
})(ErrorCode || {});
var ERROR_CODE_STATUS_MAP = {
  ["R2S_DEAL_EXPIRED" /* R2S_DEAL_EXPIRED */]: 410,
  ["R2S_DEAL_FULL" /* R2S_DEAL_FULL */]: 409,
  ["R2S_DEAL_NOT_ACTIVE" /* R2S_DEAL_NOT_ACTIVE */]: 409,
  ["R2S_DEAL_NOT_FOUND" /* R2S_DEAL_NOT_FOUND */]: 404,
  ["R2S_DEAL_LIMIT_REACHED" /* R2S_DEAL_LIMIT_REACHED */]: 403,
  ["R2S_DEAL_INVALID_CURVE" /* R2S_DEAL_INVALID_CURVE */]: 400,
  ["R2S_CLAIM_EXISTS" /* R2S_CLAIM_EXISTS */]: 409,
  ["R2S_CLAIM_NOT_FOUND" /* R2S_CLAIM_NOT_FOUND */]: 404,
  ["R2S_CLAIM_ALREADY_VALIDATED" /* R2S_CLAIM_ALREADY_VALIDATED */]: 409,
  ["R2S_CLAIM_EXPIRED" /* R2S_CLAIM_EXPIRED */]: 410,
  ["R2S_QR_INVALID" /* R2S_QR_INVALID */]: 400,
  ["R2S_QR_EXPIRED" /* R2S_QR_EXPIRED */]: 410,
  ["R2S_WRONG_STORE" /* R2S_WRONG_STORE */]: 403,
  ["R2S_AUTH_REQUIRED" /* R2S_AUTH_REQUIRED */]: 401,
  ["R2S_FORBIDDEN" /* R2S_FORBIDDEN */]: 403,
  ["R2S_USER_NOT_FOUND" /* R2S_USER_NOT_FOUND */]: 404,
  ["R2S_MERCHANT_NOT_FOUND" /* R2S_MERCHANT_NOT_FOUND */]: 404,
  ["R2S_LOCATION_REQUIRED" /* R2S_LOCATION_REQUIRED */]: 400,
  ["R2S_LOCATION_INVALID" /* R2S_LOCATION_INVALID */]: 400,
  ["R2S_RATE_LIMITED" /* R2S_RATE_LIMITED */]: 429,
  ["R2S_SUBSCRIPTION_LIMIT" /* R2S_SUBSCRIPTION_LIMIT */]: 403,
  ["R2S_SUBSCRIPTION_INACTIVE" /* R2S_SUBSCRIPTION_INACTIVE */]: 403,
  ["R2S_WISHLIST_LIMIT" /* R2S_WISHLIST_LIMIT */]: 400,
  ["R2S_VALIDATION_ERROR" /* R2S_VALIDATION_ERROR */]: 400,
  ["R2S_INTERNAL_ERROR" /* R2S_INTERNAL_ERROR */]: 500
};

// src/constants/deal.constants.ts
var QR_TOKEN_TTL_SECONDS = 600;
var MAX_DEAL_DURATION_MINUTES = 60;
var MIN_DEAL_DURATION_MINUTES = 5;
var MAX_SLOTS_PER_DEAL = 100;
var TIMER_SYNC_INTERVAL_SECONDS = 30;
var DEFAULT_DECAY_CURVE = {
  tiers: [
    { fromMinutes: 0, toMinutes: 5, discountPercent: 50 },
    { fromMinutes: 5, toMinutes: 15, discountPercent: 40 },
    { fromMinutes: 15, toMinutes: 30, discountPercent: 20 },
    { fromMinutes: 30, toMinutes: 60, discountPercent: 10 }
  ],
  expiresAfterMinutes: 60
};

// src/constants/notification.constants.ts
var DEFAULT_NOTIFICATION_RADIUS = 1e3;
var MAX_NOTIFICATIONS_PER_DAY = 3;
var DEFAULT_QUIET_HOURS = {
  start: "22:00",
  end: "08:00"
};
var NOTIFICATION_COOLDOWN_MINUTES = 60;

// src/constants/geo.constants.ts
var EARTH_RADIUS_METERS = 63710088e-1;
var GEOFENCE_ARRIVAL_RADIUS_METERS = 100;
var LOCATION_TTL_SECONDS = 300;
var WALKING_SPEED_METERS_PER_MINUTE = 80;
var DEFAULT_RADIUS_M = 2e3;
var MAX_RADIUS_M = 1e4;

// src/constants/matching.constants.ts
var MATCHING_SCORE_THRESHOLD = 40;
var SCORE_SIZE_EXACT = 30;
var SCORE_SIZE_CLOSE = 10;
var SCORE_CATEGORY = 20;
var SCORE_BRAND = 15;
var SCORE_BUDGET = 15;
var SCORE_GENDER = 10;
var SCORE_WISHLIST = 50;
var SCORE_STYLE = 10;
var DISTANCE_PENALTY_PER_100M = -1;
var PAST_ENGAGEMENT_BONUS = 5;
var PAST_ENGAGEMENT_BONUS_MAX = 20;
var RECENCY_PENALTY = -20;

// src/constants/validation.constants.ts
var SUPPORTED_CURRENCIES = ["AZN", "USD", "EUR"];
var MAX_DISPLAY_NAME_LENGTH = 100;
var MAX_WISHLIST_ITEMS = 20;
var MAX_DEAL_IMAGES = 10;
var MAX_NAME_LENGTH = 200;

// src/utils/decay-calculator.ts
function calculateDecay(curve, publishedAt, now = /* @__PURE__ */ new Date()) {
  const elapsedMs = now.getTime() - publishedAt.getTime();
  const elapsedMinutes = elapsedMs / 6e4;
  if (elapsedMinutes < 0) {
    return {
      discountPercent: 0,
      status: "not_started" /* NotStarted */,
      secondsUntilNextDrop: null,
      nextDiscountPercent: null,
      currentTierIndex: null
    };
  }
  let currentTier = null;
  let nextTier = null;
  let tierIndex = null;
  for (let i = 0; i < curve.tiers.length; i++) {
    const t = curve.tiers[i];
    if (elapsedMinutes >= t.fromMinutes && elapsedMinutes < t.toMinutes) {
      currentTier = t;
      tierIndex = i;
      nextTier = i + 1 < curve.tiers.length ? curve.tiers[i + 1] : null;
      break;
    }
  }
  if (currentTier === null) {
    return {
      discountPercent: 0,
      status: "expired" /* Expired */,
      secondsUntilNextDrop: null,
      nextDiscountPercent: null,
      currentTierIndex: null
    };
  }
  const boundaryMinutes = nextTier ? nextTier.fromMinutes : currentTier.toMinutes;
  const secondsUntilNextDrop = Math.max(
    0,
    Math.round((boundaryMinutes - elapsedMinutes) * 60)
  );
  return {
    discountPercent: currentTier.discountPercent,
    status: "active" /* Active */,
    secondsUntilNextDrop,
    nextDiscountPercent: nextTier?.discountPercent ?? null,
    currentTierIndex: tierIndex
  };
}
function calculateFinalPrice(originalPrice, discountPercent) {
  const discounted = originalPrice * (100 - discountPercent) / 100;
  return Math.round(discounted * 100) / 100;
}
function validateDecayCurve(curve) {
  const errors = [];
  if (!curve.tiers || curve.tiers.length === 0) {
    errors.push("Decay curve must have at least 1 tier.");
    return errors;
  }
  if (curve.tiers[0].fromMinutes !== 0) {
    errors.push("First tier must start at 0 minutes.");
  }
  for (let i = 0; i < curve.tiers.length; i++) {
    const tier = curve.tiers[i];
    if (tier.fromMinutes >= tier.toMinutes) {
      errors.push(
        `Tier ${i}: fromMinutes (${tier.fromMinutes}) must be less than toMinutes (${tier.toMinutes}).`
      );
    }
    if (tier.discountPercent < 1 || tier.discountPercent > 99) {
      errors.push(
        `Tier ${i}: discountPercent (${tier.discountPercent}) must be between 1 and 99.`
      );
    }
    if (i > 0) {
      const prevTier = curve.tiers[i - 1];
      if (tier.fromMinutes !== prevTier.toMinutes) {
        errors.push(
          `Tier ${i}: fromMinutes (${tier.fromMinutes}) must equal previous tier's toMinutes (${prevTier.toMinutes}).`
        );
      }
    }
    if (i > 0) {
      const prevTier = curve.tiers[i - 1];
      if (tier.discountPercent >= prevTier.discountPercent) {
        errors.push(
          `Tier ${i}: discountPercent (${tier.discountPercent}) must be less than previous tier (${prevTier.discountPercent}).`
        );
      }
    }
  }
  const lastTier = curve.tiers[curve.tiers.length - 1];
  if (curve.expiresAfterMinutes !== lastTier.toMinutes) {
    errors.push(
      `expiresAfterMinutes (${curve.expiresAfterMinutes}) must equal last tier's toMinutes (${lastTier.toMinutes}).`
    );
  }
  if (curve.expiresAfterMinutes < MIN_DEAL_DURATION_MINUTES) {
    errors.push(
      `expiresAfterMinutes (${curve.expiresAfterMinutes}) must be at least ${MIN_DEAL_DURATION_MINUTES} minutes.`
    );
  }
  if (curve.expiresAfterMinutes > MAX_DEAL_DURATION_MINUTES) {
    errors.push(
      `expiresAfterMinutes (${curve.expiresAfterMinutes}) must be at most ${MAX_DEAL_DURATION_MINUTES} minutes.`
    );
  }
  return errors;
}

// src/utils/geo-utils.ts
function toRadians(degrees) {
  return degrees * (Math.PI / 180);
}
function calculateDistance(p1, p2) {
  const lat1 = toRadians(p1.lat);
  const lat2 = toRadians(p2.lat);
  const dLat = toRadians(p2.lat - p1.lat);
  const dLng = toRadians(p2.lng - p1.lng);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return EARTH_RADIUS_METERS * c;
}
function calculateBoundingBox(center, radiusMeters) {
  const latDelta = radiusMeters / EARTH_RADIUS_METERS * (180 / Math.PI);
  const lngDelta = radiusMeters / (EARTH_RADIUS_METERS * Math.cos(toRadians(center.lat))) * (180 / Math.PI);
  return {
    sw: {
      lat: center.lat - latDelta,
      lng: center.lng - lngDelta
    },
    ne: {
      lat: center.lat + latDelta,
      lng: center.lng + lngDelta
    }
  };
}
function isWithinRadius(p1, p2, radiusMeters) {
  return calculateDistance(p1, p2) <= radiusMeters;
}
function formatDistance(meters) {
  if (meters < 1e3) {
    return `${Math.round(meters)}m`;
  }
  return `${(meters / 1e3).toFixed(1)}km`;
}
function estimateWalkingTime(meters) {
  return Math.max(1, Math.ceil(meters / WALKING_SPEED_METERS_PER_MINUTE));
}
function roundLocation(point, precision = 3) {
  const factor = Math.pow(10, precision);
  return {
    lat: Math.round(point.lat * factor) / factor,
    lng: Math.round(point.lng * factor) / factor
  };
}

// src/utils/formatters.ts
function formatCurrency(amount, currency) {
  const formatted = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
  return `${formatted} ${currency}`;
}
function formatTimeRemaining(seconds) {
  const clamped = Math.max(0, Math.floor(seconds));
  const mins = Math.floor(clamped / 60);
  const secs = clamped % 60;
  return `${mins}:${secs.toString().padStart(2, "0")}`;
}
function formatDiscount(percent) {
  return `${Math.round(percent)}% OFF`;
}
function formatSavings(originalPrice, finalPrice, currency) {
  const saved = originalPrice - finalPrice;
  return `~~${formatCurrency(originalPrice, currency)}~~ ${formatCurrency(finalPrice, currency)} (Save ${formatCurrency(saved, currency)})`;
}

// src/validators/index.ts
function isValidDecayCurve(curve) {
  return validateDecayCurve(curve).length === 0;
}
function isValidLocation(point) {
  if (typeof point.lat !== "number" || typeof point.lng !== "number") return false;
  if (!isFinite(point.lat) || !isFinite(point.lng)) return false;
  if (point.lat < -90 || point.lat > 90) return false;
  if (point.lng < -180 || point.lng > 180) return false;
  return true;
}
function sanitizeDisplayName(name) {
  if (!name || typeof name !== "string") return null;
  const cleaned = name.trim().replace(/[\x00-\x1F\x7F]/g, "").replace(/\s+/g, " ").slice(0, 100);
  return cleaned.length > 0 ? cleaned : null;
}
function isValidCurrency(currency) {
  return /^[A-Z]{3}$/.test(currency);
}

export { Category, ClaimStatus, ClaimValidationMethod, DEFAULT_DECAY_CURVE, DEFAULT_NOTIFICATION_RADIUS, DEFAULT_QUIET_HOURS, DEFAULT_RADIUS_M, DISTANCE_PENALTY_PER_100M, DealSource, DealStatus, DecayStatus, EARTH_RADIUS_METERS, ERROR_CODE_STATUS_MAP, ErrorCode, GEOFENCE_ARRIVAL_RADIUS_METERS, LOCATION_TTL_SECONDS, MATCHING_SCORE_THRESHOLD, MAX_DEAL_DURATION_MINUTES, MAX_DEAL_IMAGES, MAX_DISPLAY_NAME_LENGTH, MAX_NAME_LENGTH, MAX_NOTIFICATIONS_PER_DAY, MAX_RADIUS_M, MAX_SLOTS_PER_DEAL, MAX_WISHLIST_ITEMS, MIN_DEAL_DURATION_MINUTES, NOTIFICATION_COOLDOWN_MINUTES, NotificationPriority, PAST_ENGAGEMENT_BONUS, PAST_ENGAGEMENT_BONUS_MAX, QR_TOKEN_TTL_SECONDS, RECENCY_PENALTY, SCORE_BRAND, SCORE_BUDGET, SCORE_CATEGORY, SCORE_GENDER, SCORE_SIZE_CLOSE, SCORE_SIZE_EXACT, SCORE_STYLE, SCORE_WISHLIST, SUPPORTED_CURRENCIES, TIMER_SYNC_INTERVAL_SECONDS, UserRole, WALKING_SPEED_METERS_PER_MINUTE, calculateBoundingBox, calculateDecay, calculateDistance, calculateFinalPrice, estimateWalkingTime, formatCurrency, formatDiscount, formatDistance, formatSavings, formatTimeRemaining, isValidCurrency, isValidDecayCurve, isValidLocation, isWithinRadius, roundLocation, sanitizeDisplayName, validateDecayCurve };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map